import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import * as ImIcons from 'react-icons/im';
import { SidebarData } from './SidebarData';
import SubMenu from './SubMenu';
import { IconContext } from 'react-icons/lib';
import auth from '../services/authService';
import NotificationsDrawer from "./NotificationsDrawer";
import { Badge } from "antd";
import { BellFilled } from '@ant-design/icons';
import NotificationsContext from "../context/notificationsContext";

const Nav = styled.div`
  background: #202022;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const NavIcon = styled(Link)`
  margin-left: 2rem;
  font-size: 2rem;
  height: 80px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const NavIcon2 = styled.div`
  margin-right: 2rem;
  font-size: 1rem;
  display: flex;
  align-items: center;
  color: burlywood;
`;

const SidebarNav = styled.nav`
  background: #202022;
  width: 250px;
  height: 100vh;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  left: ${({ sidebar }) => (sidebar ? '0' : '-100%')};
  transition: 350ms;
  z-index: 10;
`;

const SidebarWrap = styled.div`
  width: 100%;
`;

const SidebarWrapContent = styled.div`
  width: 100%;
  overflow-y: auto;
`;

const ContentDiv = styled.div`
  display: flex;
`;

const SidebarLink = styled.div`
  display: flex;
  color: #e1e9fc;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  list-style: none;
  height: 60px;
  text-decoration: none;
  font-size: 18px;

  &:hover {
    background: #545450 ;
    border-left: 4px solid #FFFFFF;
    cursor: pointer;
    color: #e1e9fc;
  }

  &:active {
    color: #e1e9fc;
  }
`;

const SidebarLabel = styled.span`
  margin-left: 16px;
`;

const Sidebar = () => {
  const [sidebar, setSidebar] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const user = auth.getCurrentUser();

  const handleLogOut = () => {
    auth.logout();
    window.location = "/gralta/login";
  };

  const showSidebar = () => setSidebar(!sidebar);

  return (<NotificationsContext.Consumer>
    {ctx => <React.Fragment>
      <NotificationsDrawer visible={showNotifications} onClose={() => setShowNotifications(false)} />
      <IconContext.Provider value={{ color: '#fff' }}>
        <Nav>
          <NavIcon to='#'>
            <FaIcons.FaBars onClick={showSidebar} />
          </NavIcon>
          <ContentDiv>
            <NavIcon2>
              <Badge count={ctx.notifications.filter(n => n.isRead === false).length} size="small">
                <BellFilled style={{ fontSize: "30px" }} onClick={() => setShowNotifications(true)} />
              </Badge>
            </NavIcon2>
            <NavIcon2>
              <span><FaIcons.FaUser className='c-burlywood'/> : {user.username}</span>
            </NavIcon2>
          </ContentDiv>
        </Nav>
        <SidebarNav sidebar={sidebar}>
          <SidebarWrap>
          <NavIcon to='#'>
              <AiIcons.AiOutlineClose onClick={showSidebar} />
            </NavIcon>
            <SidebarWrapContent className='scrollNav'>
            {SidebarData.map((item, index) => {
              return <SubMenu item={item} key={index} showSidebar={showSidebar}/>;
            })}
            {user && <SidebarLink onClick={handleLogOut}>
                <div>
                  <ImIcons.ImExit/>
                  <SidebarLabel>Salir</SidebarLabel>
                </div>
              </SidebarLink>}
            </SidebarWrapContent>
          </SidebarWrap>
        </SidebarNav>
      </IconContext.Provider>
    </React.Fragment>}
  </NotificationsContext.Consumer>);
};

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/Sidebar.js